import React, { Component } from "react"
import * as styles from "./usage.module.scss"
import UsageForm from "../usageForm/usageForm"
import { TM } from "../../common/typography/trademark"

const personalUsage = {
  heading: "Personal Usage",
  price: "$0.00",
  textArray: [
    {
      text: (
        <>
          Protected by IronCAP
          <TM /> Cryptography
        </>
      ),
    },
    {
      text: "Send/Receive Encrypted Emails",
    },
    {
      text: "Encrypt Sensitive Files",
    },
    {
      text: "Digitally Sign your Emails/Files",
    },
    {
      text: "Free Unlimited Personal Usage",
    },
    {
      text: "No Credit Card Required",
    },
    {
      text: "One User Per Account",
    },
  ],
}

const businessUsage = {
  heading: "Business Usage",
  price: "$99.95",
  textArray: [
    {
      text: (
        <>
          Protected by IronCAP
          <TM /> Cryptography
        </>
      ),
    },
    {
      text: "Send/Receive Encrypted Emails",
    },
    {
      text: "Encrypt Sensitive Files",
    },
    {
      text: "Digitally Sign your Emails/Files",
    },
    {
      text: "Unlimited Business Usage",
    },
    {
      text: "Central Business Administration",
    },
    {
      text: "Multiple Users per Account",
    },
  ],
}

class Usage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ie: false,
    }
  }
  componentDidMount() {
    if (typeof window !== `undefined`) {
      let isIE = /*@cc_on!@*/ false || !!document.documentMode
      this.setState({
        ie: isIE,
      })
    }
  }
  render() {
    return (
      <div className={styles.usageSection}>
        <div
          className={
            this.state.ie ? styles.usageContainerIE : styles.usageContainer
          }
        >
          <div
            className={
              this.state.ie ? styles.usageColumnIE : styles.usageColumn
            }
          >
            {this.props.usage === "Personal" ? (
              <div className={styles.columnHeader}>
                <p>{personalUsage.heading}</p>
                <p>{personalUsage.price}</p>
                <p className={styles.personalUsageDisclaimer}>
                  IronCAP X<TM /> provides an unlimited free usage for personal
                  accounts. We only charge for commercial business usage.
                </p>
              </div>
            ) : (
              <div className={styles.columnHeader}>
                <p>{businessUsage.heading}</p>
                <p>{businessUsage.price}</p>
                <p className={styles.columnTagline}>per user/yr</p>
                <div className={styles.businessUsageDisclaimer}>
                  <p>Risk-Free Trial:</p>
                  <p>
                    You can install and activate a FREE Personal Usage account
                    to try the software. The Terms of Service allows a business
                    entitiy to use a FREE Personal account for 30 days.
                  </p>
                </div>
                <div className={styles.businessUsageDisclaimer}>
                  <p>Already have a FREE Personal account:</p>
                  <p>
                    There is no need to reinstall. Simply select "My Account" on
                    your IronCAP X<TM /> software to upgrade to a Business
                    account.
                  </p>
                </div>
              </div>
            )}
          </div>
          <div
            className={
              this.state.ie ? styles.usageColumnIE : styles.usageColumn
            }
          >
            <UsageForm />
          </div>
          <div
            className={
              this.state.ie ? styles.usageColumnIE : styles.usageColumn
            }
          >
            {this.props.usage === "Personal"
              ? personalUsage.textArray.map(textItem => {
                  return (
                    <div className={styles.columnItem}>
                      <p>{textItem.text}</p>
                      <div />
                    </div>
                  )
                })
              : businessUsage.textArray.map(textItem => {
                  return (
                    <div className={styles.columnItemBiz}>
                      <p>{textItem.text}</p>
                      <div />
                    </div>
                  )
                })}
          </div>
        </div>
      </div>
    )
  }
}

export default Usage
